import { useTranslation } from "react-i18next";
import { Text, ThemeColorVariable, TStep } from "@caspeco/casper-ui-library";

export const AwaitingConfirmationStep = (): TStep => {
	const { t } = useTranslation();
	return {
		label: (
			<Text color={ThemeColorVariable.OnBackgroundHeader}>{t("order_status_awaiting_confirmation")}</Text>
		),
		color: ThemeColorVariable.Success,
		dividerColor: ThemeColorVariable.Success,
		icon: "spinner",
	};
};
